import type { IconRootProps } from './Root'
import { IconRoot } from './Root'

export const CampaignIcon = ({
  className,
  size = '1rem',
  color = 'currentColor',
}: IconRootProps) => (
  <IconRoot
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    size={size}
  >
    <path
      d="M5.60668 4.15727C6.28988 2.42499 6.63148 1.55885 7.093 1.26456C7.64622 0.911812 8.35378 0.911812 8.907 1.26456C9.36852 1.55885 9.71012 2.42499 10.3933 4.15727C10.532 4.50881 10.6013 4.68459 10.7028 4.83588C10.8251 5.01822 10.9818 5.17494 11.1641 5.29724C11.3154 5.3987 11.4912 5.46803 11.8427 5.60668C13.575 6.28988 14.4411 6.63148 14.7354 7.093C15.0882 7.64622 15.0882 8.35378 14.7354 8.907C14.4411 9.36852 13.575 9.71012 11.8427 10.3933C11.4912 10.532 11.3154 10.6013 11.1641 10.7028C10.9818 10.8251 10.8251 10.9818 10.7028 11.1641C10.6013 11.3154 10.532 11.4912 10.3933 11.8427C9.71012 13.575 9.36852 14.4411 8.907 14.7354C8.35378 15.0882 7.64622 15.0882 7.093 14.7354C6.63148 14.4411 6.28988 13.575 5.60668 11.8427C5.46803 11.4912 5.3987 11.3154 5.29724 11.1641C5.17494 10.9818 5.01822 10.8251 4.83588 10.7028C4.68459 10.6013 4.50881 10.532 4.15727 10.3933C2.42499 9.71012 1.55885 9.36852 1.26456 8.907C0.911812 8.35378 0.911812 7.64622 1.26456 7.093C1.55885 6.63148 2.42499 6.28988 4.15727 5.60668C4.50881 5.46803 4.68459 5.3987 4.83588 5.29724C5.01822 5.17494 5.17494 5.01822 5.29724 4.83588C5.3987 4.68459 5.46803 4.50881 5.60668 4.15727Z"
      fill={color}
    />
  </IconRoot>
)
